import { makeStyles } from '@material-ui/styles';
import { Model } from '@type-r/models';
import { useLinked } from '@type-r/react';
import { Flex, FormSelect, Option } from 'lqx-react/lib';
import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { BooleanFilter, EnterBoolean } from './filters/boolean-filter';
import { DateRangeFilter, EnterRange } from './filters/date-range-filter';
import { EnterMultiSelect, MultiSelectFilter } from './filters/multiselect-filter';
import { EnterMultiSelectChips, MultiSelectChipsFilter } from './filters/multiselect-chips-filter';
import { EnterText, SearchInput, TextFilter } from './filters/text-filter';
import { useLabels } from './utils';
import { DropdownFilter, EnterDropdown } from './filters/dropdown-filter';
import { DateFilter, EnterDate } from './filters/date-filter';
import { EnterMultiSelectChipsAsync, MultiSelectChipsAsyncFilter } from './filters/multiselect-chips-async-filter';

export const isValid = value => value && (value.isValid ? value.isValid() : true);

export const AddFilter = ({ className, filter, filterAllPlaceholder, selectedFilterBy }: {
    className: string,
    filter: Model,
    filterAllPlaceholder?: String,
    selectedFilterBy?: String
}) => {
    const labels = useLabels(filter);
    const classes = useStyles();

    const emptyFilters = useMemo(() => {
        const emptyFilters = [];

        for (let key in filter.attributes) {
            if (key !== 'id' && key !== 'sortBy' && key !== 'stateId') {
                if (key !== 'filterAll') {
                    emptyFilters.push(key);
                }
                else if (!filter[key].isInitial) {
                    emptyFilters.push(key);
                }
            }
        }

        return emptyFilters;
    }, [filter['_changeToken']]);

    const $filterBy = useLinked(emptyFilters[0]).onChange(() => (filter as any).reset());

    useEffect(() => {
        if (selectedFilterBy && emptyFilters.includes(selectedFilterBy)) {
            $filterBy.set(selectedFilterBy);
        }
    }, [selectedFilterBy])

    useEffect(() => {
        if (!emptyFilters.includes($filterBy.value)) {
            $filterBy.set(emptyFilters[0]);
        }
    }, [emptyFilters])
    if (!$filterBy.value) {
        return <div />
    }

    const Attr = filter['_attributes'][$filterBy.value];

    const EnterAttr: any =
        Attr.type === DateRangeFilter ? EnterRange :
            Attr.type === MultiSelectFilter ? EnterMultiSelect :
                Attr.type === DropdownFilter ? EnterDropdown :
                    Attr.type === BooleanFilter ? EnterBoolean :
                        Attr.type === MultiSelectChipsFilter ? EnterMultiSelectChips :
                            Attr.type === DateFilter ? EnterDate :
                                Attr.type === MultiSelectChipsAsyncFilter ? EnterMultiSelectChipsAsync: EnterText;

    const filterAll = $filterBy.value === 'filterAll';

    const textInput = Attr.type === TextFilter;

    return (
        <Flex row className={classes.root}>
            <FormSelect classes={{ root: 'formSelect formSelectWidth' }} $value={$filterBy}>
                {emptyFilters.map(key =>
                    <Option value={key} key={key}>
                        {labels[key] || Attr.name}
                    </Option>
                )}
            </FormSelect>

            {filterAll ?
                <SearchInput
                    classes={{ root: 'searchInput' }}
                    $value={(filter as any).$.filterAll}
                    placeholder={filterAllPlaceholder || "Filter by all fields"}
                />
                :
                textInput ?
                    <SearchInput
                        classes={{ root: 'searchInput' }}
                        $value={(filter as any).$[$filterBy.value].value.$.value}
                        placeholder={`Filter by ${labels[$filterBy.value]}`}
                    />
                    :
                    <EnterAttr key={$filterBy.value} filterName={$filterBy.value} filterValue={filter[$filterBy.value]}
                        onEnter={
                            range => (filter as any).$[$filterBy.value].set(range)
                        }
                    />
            }
        </Flex>
    )
}

const useStyles = makeStyles({
    root: {
        padding: '4px 10px 4px 4px',
        "& .formSelect": {
            width: ' 180px',
            marginRight: '8px'
        },
        "& .searchInput": {
            width: "500px",
            border: "1px solid #c4c4c4",
            borderRadius: "4px",
            marginRight: "5px",
            color: "#c4c4c4",
            fontSize: "13px",
            padding: "1px 25px 1px 10px",
            margin: '4px 0',
            "&:hover": {
                border: "1px solid black"
            }
        },
        "& .MuiFormControl-root": {
            "& .select-root": {
                border: "none",
            },
            "& fieldset": {
                border: "none",
            },
            "&:hover": {
                border: "1px solid black"
            },
            "& .MuiAutocomplete-inputRoot":{
                padding: "2px 6px"
            }
        },
        "& .select-input-root": {
            width: "500px",
            backgroundColor: "white",
            border: "1px solid #c4c4c4",
            padding: "0 5px",
            borderRadius: "4px",
            marginRight: "5px",
            "& .MuiFilledInput-root .MuiSelect-select": {
                backgroundColor: "white",
                border: "none",
                color: "#c4c4c4",
            },
            "&:hover": {
                border: "1px solid black"
            },
            
        },
        "& .formSelectWidth": {
            "& .MuiInputBase-root":{
                maxWidth: '163px'
            }
        }
    }

})
